/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 12th 2022, 6:34:31 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { logger } from "lib/logger";

export const useCopyTextToClipBoard = () => {
  const [copied, setCopied] = React.useState<boolean>(false);
  const [copiedText, setCopiedText] = React.useState<string>();

  const copyTextToClipBoard = (copyText: string) => {
    if (!window.isSecureContext) {
      // Clipboard API only works in secure context - https://developer.mozilla.org/en-US/docs/Web/API/Clipboard_API
      logger.error(
        "Cannot copy to clipboard in unsecure context. The Javascript Clipboard API only works with a secure origin, either HTTPS or localhost"
      );
      return;
    }

    navigator.clipboard.writeText(copyText);
    setCopied(true);
    setCopiedText(copyText);
  };

  return { copyTextToClipBoard, copied, setCopied, copiedText };
};
